import React, { useEffect } from 'react';
import {
    Card, CardBody, CardTitle,
    Col,
    Row
} from 'reactstrap';

import {ButtonCancel, ButtonNew, GenericTableButton} from "../../../components/buttons/buttonsActions";


import {connect} from "react-redux";
import {confirmAlert} from "react-confirm-alert";
import {ProgramDetailForm} from "./_form";
import {LIST, NO_DATA_FOUND} from "../../../components/i18n/i18n";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import {TT_DELETE, TT_EDIT} from "../../../components/i18n/toolTips";
import {ConfirmDelete} from "../../../components/confirmAlert/ConfirmDelete";
import {ActiveFormatter} from "../../../components/tables/activeFormater";

import {
    clearState,
    setApp,
    setLoading,
    setUdn,
    setViewMode
} from "../../../redux/actions/generalActions/mainActions";
import {save, update, search} from "../../../redux/actions/atv/programDetailActions";
import {setTableParams} from "../../../redux/actions/generalActions/subFormActions";

const ProgramDetail = (props) => {
    const fbDataBaseId = props.mainProps?.app?.fbDataBase?.id
    const { pageSize, pageIndex, totalSize, listChildObjects, filter } = props.subFormProps
    const { domainObject } = props.formProps
    const dataFilter = {
        fbDataBase : {  id : fbDataBaseId },
        item : {
            program : { id: domainObject.id }
        }
    }

    useEffect(() => {
        if ( filter === undefined || filter === null){
            refreshDataList(pageIndex, pageSize, dataFilter);
            return
        }

        refreshDataList(pageIndex, pageSize, filter);
    }, [pageIndex, pageSize, filter]);

    const refreshDataList =  (_pageIndex, _pageSize, _filter) => props.search(_pageIndex, _pageSize, _filter)

    const handleTableChange = (type, tableChangeParams) => {
        let currentIndex = (tableChangeParams.page - 1) * tableChangeParams.sizePerPage;
        props.setTableParams( tableChangeParams.sizePerPage, currentIndex );
    };

    // ----------------------------------------------
    //            CHANGE HANDLERS
    // ----------------------------------------------
    const onNew = ( ) => confirmAlert({
        closeOnEscape: true,
        closeOnClickOutside: true,
        customUI: ({onClose}) =>
            <>
                <ProgramDetailForm
                    program={domainObject}
                    fbDataBaseId={fbDataBaseId}
                    onClose={onClose}
                    save={props.save}
                />
            </>
    });

    const onEdit = ( item ) => confirmAlert({
        closeOnEscape: true,
        closeOnClickOutside: true,
        customUI: ({onClose}) =>
            <>
                <ProgramDetailForm
                    program={domainObject}
                    programDetail={item}
                    fbDataBaseId={fbDataBaseId}
                    onClose={onClose}
                    update={props.update}
                />
            </>
    });

    const confirmDelete = (data) => {
        return ConfirmDelete({
            data,
            fbDataBaseId : fbDataBaseId,
            remove : props.remove
        });
    };

    const onClose = () => {
        props.setViewMode('LIST');
    };

    const activeFormatter = (cell) => {
        return (
            <ActiveFormatter active={cell}/>
        );
    }

    const actionsFormatter = (cell, row) => {
        return (
            <div className="float-left">
                <GenericTableButton toolTip={TT_EDIT} icon={'fa-pen'} permission={'edit'} onClick={() => onEdit(row)}/>
                <GenericTableButton toolTip={TT_DELETE} icon={'fa-trash'} permission={'delete'} onClick={() => confirmDelete(row)}/>
            </div>
        );
    }

    const columns = [{
        dataField: 'id',
        text: 'ID',
        headerStyle: {width: '0px'},
        hidden: true
    }, {
        dataField: 'title',
        text: 'Titulo'
    }, {
        dataField: 'showOrder',
        headerStyle: {width: '50px'},
        text: "Orden de presentación"
    }, {
        dataField: 'status',
        headerStyle: {width: '50px'},
        text: "Activo",
        formatter: activeFormatter
    }, {
        isDummyField: true,
        text: 'Acción',
        headerStyle: {width: '180px'},
        formatter: actionsFormatter
    }
    ];

    return (
        <div>
            <Row>
                <Col md="12">
                    <div className="d-flex align-items-center">
                        <div className="ml-auto paddingAdd">
                            <ButtonCancel onClick={ onClose }/>
                            <ButtonNew onClick={ () => onNew( fbDataBaseId )}/>
                        </div>
                    </div>
                </Col>
            </Row>
            <Row>
                <Col md="12">
                    <Card>
                        <CardTitle className="bg-light border-bottom p-3 mb-0">
                            <i className="far fa-list-alt mr-2"> </i>{LIST}
                            <div className="float-right">
                                {/*<ButtonTableFilter onClick={() => showFilters()} collapsed={collapsed}/>*/}
                            </div>
                        </CardTitle>
                        <CardBody className="">
                            <BootstrapTable
                                striped hover
                                tableHeaderClass='mb-0'
                                remote
                                keyField="id"
                                data={listChildObjects || []}
                                columns={columns}
                                noDataIndication={NO_DATA_FOUND}
                                pagination={paginationFactory({pageIndex, pageSize, totalSize})}
                                onTableChange={handleTableChange}
                            />
                        </CardBody>
                    </Card>
                </Col>
            </Row>
        </div>
    );
}

const mapStateToProps = state => ({
    mainProps : state.mainProps,
    formProps : state.formProps,
    subFormProps : state.subFormProps
});

const mapActionsToProps = ({
    clearState,
    setTableParams,
    setUdn,
    setApp,
    setViewMode,
    setLoading,
    save,
    update,
    search
});

export default connect(mapStateToProps, mapActionsToProps)(ProgramDetail)
